import {useEffect} from 'react';
import {createSharedValueKey, useSharedValue} from '@epic-core/hooks';
import {useMiscStore} from 'epic-ue-shared';
import {statusApi, StatusResponse} from './status.api';
import {isError} from '@epic-mw/error-types';

export const epicStatusKey = createSharedValueKey<StatusResponse>('epicStatusKey', {
    status: {},
    incidents: []
});

const loadingState = {
    loading: false,
    loaded: false,
    error: ''
};

interface EpicStatusRes {
    epicStatus: StatusResponse;
    loading: boolean;
    loaded: boolean;
    error: string;
}

export const useEpicStatus = (): EpicStatusRes => {
    const [epicStatus, setEpicStatus] = useSharedValue<StatusResponse>(epicStatusKey);
    const miscStore = useMiscStore();
    const epicStatusApi = miscStore.epicStatusApi || '';

    useEffect(() => {
        if ((epicStatus && !loadingState.error) || loadingState.loading || loadingState.loaded) {
            return;
        }
        async function fetchData() {
            try {
                loadingState.loading = true;
                const status = await statusApi.getStatus(epicStatusApi);
                loadingState.loading = false;
                loadingState.loaded = true;
                setEpicStatus(status);
            } catch (ex) {
                console.error('Failed to get account', ex);
                loadingState.loading = false;
                loadingState.loaded = true;
                loadingState.error = (isError(ex) && ex.message) || '';
            }
        }
        fetchData();
    }, [epicStatus, loadingState]);

    return {
        epicStatus,
        ...loadingState
    };
};
